export const calcGrowth = (current: number, previous: number) => {
  if (!previous || previous === 0) return current === 0 ? 0 : Infinity;
  return (current - previous) / previous;
};
